import { Component, OnInit } from '@angular/core';
import { AnimationReunion, AnimationReunionAll } from '@app/models/animationReunion';
import { ContratAccueilMentalo, EnfantMentalo } from '@app/models/contrat-accueil';
import { ConfigMentalo } from '@app/models/mentalo';
import { BaseConfigService, PermissionService, PlatformService, SnackbarService, UserService } from '@app/services';
import { AssmatService } from '@app/services/assmat.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-list-reunions',
  templateUrl: './list-reunions.component.html',
  styleUrls: ['./list-reunions.component.scss'],
  standalone: false
})
export class ListReunionsComponent implements OnInit {

  idAssmat: number;
  listAllReunions: AnimationReunionAll;
  listChild: EnfantMentalo[];
  listContrats: ContratAccueilMentalo[];
  permToAdd: boolean;
  loadingData: boolean;
  configMentalo: ConfigMentalo;

  constructor(
    private assmatService: AssmatService,
    private userService: UserService,
    public platformService: PlatformService,
    private snackbar: SnackbarService,
    private permService: PermissionService,
    private configService: BaseConfigService
  ) { }

  ngOnInit(): void {
    this.permToAdd = this.permService.hasPermission('reunions_add');
    this.idAssmat = this.userService.currentUser.idAssmat || null;
    this.loadReunions();
  }

  loadReunions() {
    forkJoin([
      this.assmatService.getReunionsByIdAssmat(this.idAssmat),
      this.assmatService.getEnfantsMentaloByIdAssMat(this.idAssmat),
      this.assmatService.getContratsAccueilByIdAssMat(this.idAssmat),
      this.configService.get<ConfigMentalo>("mentalo")
    ]).subscribe(([reunions, childList, contrats, config]: [AnimationReunionAll, EnfantMentalo[], ContratAccueilMentalo[], ConfigMentalo]) => {
      this.configMentalo = config;
      this.listAllReunions = reunions;
      this.listChild = childList;
      this.listContrats = contrats;
      this.loadingData = true;
    });
  }

  unsubscribe(animationReunion) {
    animationReunion.saving = true;

    let animationReunionPortail = {
      idReunion: animationReunion.idReunion,
      idAssmat: this.idAssmat,
    }

    this.assmatService.desinscriptionAnimationReunion(this.idAssmat, {
      idPortailAnimationReunionAssmat: animationReunion.portailInscription?.idPortailAnimationReunionAssmat,
      selectedChild: animationReunion.listEnfantMentaloRegisteredByAssmat,
      animationReunionPortail
    }).subscribe(_ => {
      this.afterConfirm('Desinscription', animationReunion);
    }, err => this.snackbar.error('Erreur lors de la désinscription'))
  }

  unsubscribeChild(event) {
    let animationReunion = event.animationReunion;
    let child = event.child;
    animationReunion.saving = true;

    let animationReunionPortail = {
      idReunion: animationReunion.idReunion,
      idAssmat: this.idAssmat,
    }

    this.assmatService.desinscriptionChildAnimationReunion(
      this.idAssmat,
      child.child.id,
      {
        animationReunionPortail,
        idPortailAnimationReunionEnfant: child.idPortailAnimationReunionEnfant,
        childRegistered: animationReunion.listEnfantMentaloRegisteredByAssmat
      }).subscribe(_ => {
        this.afterConfirm('Desinscription', animationReunion);
      }, err => this.snackbar.error('Erreur lors de la désinscription'))
  }

  registerChild(event) {
    let animationReunion = event.animationReunion;
    let registerChildIdList = event.registerChildList;
    animationReunion.saving = true;

    let animationReunionPortail = {
      idReunion: animationReunion.idReunion,
      idAssmat: this.idAssmat,
    }

    this.assmatService.inscriptionChildAnimationReunion(
      this.idAssmat,
      {
        idPortailAnimationReunionAssmat: animationReunion.portailInscription?.idPortailAnimationReunionAssmat,
        animationReunionPortail,
        selectedChild: registerChildIdList,
        childRegistered: animationReunion.listEnfantMentaloRegisteredByAssmat
      }).subscribe(_ => {
        this.afterConfirm('Inscription', animationReunion);
      }, err => this.snackbar.error("Erreur lors de l'inscription"))
  }

  afterConfirm(typeDemande: string, reunion: AnimationReunion) {
    this.loadReunions();
    if (typeDemande === "Desinscription") {
      this.snackbar.info('Désinscription Réussie');
    } else {
      this.snackbar.info('Inscription Réussie');
    }
    reunion.saving = false;
  }

}
